// Seleção do provedor de mapa.
//
// 'leaflet' -> Leaflet + tiles OpenStreetMap (grátis, sem API key) + roteamento OSRM (grátis)
// 'here'    -> HERE Maps (implementação antiga). Mantida intacta para reverter a qualquer momento.
//
// Para reverter pro HERE, basta trocar a constante abaixo para 'here'
// (ou definir REACT_APP_MAP_PROVIDER=here no ambiente de build).
export const MAP_PROVIDER = process.env.REACT_APP_MAP_PROVIDER || "leaflet";

// Servidor público de roteamento OSRM (open-source, sem chave).
// Para volume alto, troque pela URL do seu próprio servidor OSRM.
export const OSRM_BASE_URL =
  process.env.REACT_APP_OSRM_URL || "https://router.project-osrm.org";

// Tiles do OpenStreetMap usados pelo Leaflet.
export const OSM_TILE_URL =
  process.env.REACT_APP_OSM_TILE_URL ||
  "https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png";

export const OSM_ATTRIBUTION =
  '&copy; <a href="https://www.openstreetmap.org/copyright">OpenStreetMap</a> contributors';
